import React from 'react';
import PropTypes from 'prop-types';

import classes from './CountrySelectorItem.css';
import checkIcon from '../../../../../assets/images/check_icon.svg';

const countrySelectorItem = props => {
  const {
    optionImg,
    optionTitle,
    selectedItem,
    selectCountry,
    closeSideBar
  } = props;

  let checkElement = selectedItem ? (
    <img src={checkIcon} alt="Check Icon" />
  ) : null;

  return (
    <li
      className={classes.CountrySelectorItem}
      onClick={() => {
        selectCountry();
        closeSideBar();
      }}
      onKeyDown={() => {
        selectCountry();
        closeSideBar();
      }}
    >
      <div className={classes.CountryWrapper}>
        <img src={optionImg} alt="" />
        <h3
          className={
            selectedItem ? classes.CSItemActive : classes.CSItemInactive
          }
        >
          {optionTitle}
        </h3>
      </div>
      {checkElement}
    </li>
  );
};

countrySelectorItem.propTypes = {
  optionImg: PropTypes.string.isRequired,
  optionTitle: PropTypes.string.isRequired,
  selectedItem: PropTypes.bool.isRequired,
  selectCountry: PropTypes.func,
  closeSideBar: PropTypes.func
};

export default countrySelectorItem;
